module.exports = __webpack_public_path__ + "static/media/twitter_color_icon.adb00233.png";